/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-05-23 12:17:58
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-12-22 14:48:44
 * @FilePath: /designcenter/src/api/modules/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IRes } from '@/types'
import { getApiRequest } from '@/utils'

const request = getApiRequest()

export function uploadFileService(data: FormData) {
  return request.post<IRes<string | null>>('/design/export/uploadTopologyFile', data)
}

interface IGetProjectInfo {
  projectId: number
  userId: number
  typeId: number
}

export function recordShareProject(data: IGetProjectInfo) {
  return request.post<IRes<string | null>>('/design/customer/recordShareProject', data)
}

/**
 * 客户操作类型枚举
 * 7: 客户工具访问
 * 8: 客户咨询表单提交
 * 9: 客户结算按钮点击
 * 10: 客户报价点击
 * 11: 客户购物车点击
 */
export enum CustomerOperationType {
  TOOL_ACCESS = 7,
  CONSULTATION_FORM = 8,
  SETTLEMENT_CLICK = 9,
  QUOTE_CLICK = 10,
  CART_CLICK = 11,
}

/**
 * 客户操作日志请求参数
 */
export interface ICustomerOperationLogParams {
  /** 项目id */
  projectId: number
  /** 用户id */
  userId: number
  /** 操作类型：7-11 */
  typeId: CustomerOperationType
}

/**
 * 记录客户操作日志
 * @param data 客户操作日志参数
 * @returns Promise
 */
export function recordCustomerOperation(data: ICustomerOperationLogParams) {
  return request.post<IRes<void>>('/design/customer/recordCustomerOperation', data)
}
